export default {
    alarmTypes: {
            AC_POWER_FAIL: "AC Power Fail",
            AIR_IN_METER: "Air In Meter",
            AIR_IN_METER_SHUTOFF: "Air in Meter Shutoff",
            ALARM_OVERFLOW: "Alarm Overflow",
            AVERAGE_VOLTAGE_HIGH_LIMIT: "Average Voltage High Limit",
            AVERAGE_VOLTAGE_INSIDE_RANGE: "Average Voltage Inside Range",
            AVERAGE_VOLTAGE_LOW_LIMIT: "Average Voltage Low Limit",
            AVERAGE_VOLTAGE_OUTSIDE_RANGE: "Average Voltage Outside Range",
            BACKUP_BATTERY_LOW_VOLTAGE: "Backup Battery Low Voltage",
            BATTERY: "Low Battery",
            BATTERY_CONSUMPTION_INSIDE_RANGE: "Battery Consumption Inside Range",
            BATTERY_CONSUMPTION_OUTSIDE_RANGE: "Battery Consumption Outside Range",
            BATTERY_DOOR_TAMPER: "Battery Door Tamper",
            BATTERY_LOW_VOLTAGE: "Battery Low Voltage",
            BATTERY_REMAINING_15_PERCENT: "15% of battery remaining",
            BATTERY_REMAINING_25_PERCENT: "25% of battery remaining",
            BATTERY_REMAINING_5_PERCENT: "5% of battery remaining",
            BEYOND_END_OF_LIFE: "Beyond End Of Life",
            BG_ALGAE_CHANGE_RATE_OVER_LIMIT: "BG Algae Change Rate Over Limit",
            BG_ALGAE_CHANGE_RATE_UNDER_LIMIT: "BG Algae Change Rate Under Limit",
            BG_ALGAE_INSIDE_RANGE: "BG Algae Inside Range",
            BG_ALGAE_OUTSIDE_RANGE: "BG Algae Outside Range",
            BIDIRECTIONAL_COMMUNICATION_FAILED: "Bidirectional Communication Failed",
            BLOCK_CRC_FAILED: "Block CRC Failed",
            BLOCKED_RELAY: "Blocked Relay",
            BOARD_FAILURE: "Board Failure",
            BROWN_OUT: "Brown Out",
            BROWNOUT_DETECTED: "Brownout Detected",
            CALIBRATION_LOST: "Calibration Lost",
            CASING_HIGH_VOLTAGE: "Casing High Voltage",
            CASING_LOW_VOLTAGE: "Casing Low Voltage",
            CASING_VOLTAGE_INSIDE_RANGE: "Casing Voltage Inside Range",
            CASING_VOLTAGE_OUTSIDE_RANGE: "Casing Voltage Outside Range",
            CHLOROPHYLL_CHANGE_RATE_OVER_LIMIT: "Chlorophyll Change Rate Over Limit",
            CHLOROPHYLL_CHANGE_RATE_UNDER_LIMIT: "Chlorophyll Change Rate Under Limit",
            CHLOROPHYLL_INSIDE_RANGE: "Chlorophyll Inside Range",
            CHLOROPHYLL_OUTSIDE_RANGE: "Chlorophyll Outside Range",
            CLOCK_ERROR: "Clock Error",
            COMMUNICATIONS_FAILURE_SENSOR: "Communications Failure Sensor",
            COMMUNICATIONS_WARNING: "Communications Warning",
            COMPENSATION_FAILURE: "Compensation Failure",
            CONDUCTIVITY_CHANGE_RATE_OVER_LIMIT: "Conductivity Change Rate Over Limit",
            CONDUCTIVITY_CHANGE_RATE_UNDER_LIMIT: "Conductivity Change Rate Under Limit",
            CONDUCTIVITY_INSIDE_RANGE: "Conductivity Inside Range",
            CONDUCTIVITY_OUTSIDE_RANGE: "Conductivity Outside Range",
            CONFIGURATION_ERROR: "Configuration Error",
            CONFIGURATION_ERROR_DEMAND_OR_TOU: "Configuration Error (Demand or TOU)",
            CONFIGURATION_LOST: "Configuration Lost",
            CORRECTOR_ALARM: "Corrector Alarm",
            CORRUPT_BLOCK: "Corrupt Block",
            COUNTER_OVERFLOW: "Counter Overflow",
            COUPON_HIGH_VOLTAGE: "Coupon High Voltage",
            COUPON_LOW_VOLTAGE: "Coupon Low Voltage",
            COUPON_VOLTAGE_INSIDE_RANGE: "Coupon Voltage Inside Range",
            COUPON_VOLTAGE_OUTSIDE_RANGE: "Coupon Voltage Outside Range",
            CRITICAL_HARDWARE_WARNING: "Critical Hardware Warning",
            CRITICAL_READ_TIME_DRIFT: "Critical Read Time Drift",
            CUSTOMER_LEAK: "Customer Leak",
            CUT_WIRE: "Cut Wire",
            CUT_WIRE_35_DAY: "Cut Wire 35 Day",
            CYCLING_LAMP: "Cycling Lamp",
            DALI_DRIVER_FAILURE: "DALI Driver Failure",
            DAYLIGHT_BURNER: "Daylight Burner",
            DC_CURRENT_INSIDE_RANGE: "DC Current Inside Range",
            DC_CURRENT_OUTSIDE_RANGE: "DC Current Outside Range",
            DC_DETECTED_IN_CIRCUIT: "Dc Detected in circuit",
            DC_VOLTAGE_INSIDE_RANGE: "DC Voltage Inside Range",
            DC_VOLTAGE_OUTSIDE_RANGE: "DC Voltage Outside Range",
            DEAD_BATTERY: "Dead Battery",
            DEMAND_OVERLOAD: "Demand Overload",
            DEVICE_RESET: "Device Reset",
            DEVICE_SYSTEM_ERROR: "Device System Error",
            DIGITAL_INPUT_A: "Digital Input A",
            DIGITAL_INPUT_A_ALARM_GAS: "Digital Input A Alarm Gas",
            DIGITAL_INPUT_A_ALARM_GAS_LATCHED: "Digital Input A Alarm Gas Latched",
            DIGITAL_INPUT_A_ALARM_SMARTPOINT_LATCHED: "Digital Input A Alarm SmartPoint Latched",
            DIGITAL_INPUT_A_ALARM_WATER: "Digital Input A Alarm Water",
            DIGITAL_INPUT_A_ALARM_WATER_LATCHED: "Digital Input A Alarm Water Latched",
            DIGITAL_INPUT_B: "Digital Input B",
            DIGITAL_INPUT_B_ALARM__GAS_LATCHED: "Digital Input B Alarm  Gas Latched",
            DIGITAL_INPUT_B_ALARM__WATER_LATCHED: "Digital Input B Alarm  Water Latched",
            DIGITAL_INPUT_B_ALARM_GAS: "Digital Input B Alarm Gas",
            DIGITAL_INPUT_B_ALARM_GAS_LATCHED: "Digital Input B Alarm Gas Latched",
            DIGITAL_INPUT_B_ALARM_SMARTPOINT_LATCHED: "Digital Input B Alarm SmartPoint Latched",
            DIGITAL_INPUT_B_ALARM_WATER: "Digital Input B Alarm Water",
            DISCONNECT_LOAD_SIDE_VOLTAGE_SENSE: "Disconnect Load Side Voltage Sense",
            DISCONNECT_OPEN_INDICATOR: "Disconnect Open Indicator",
            DISSOLVED_OXYGEN_CHANGE_RATE_OVER_LIMIT: "Dissolved Oxygen Change Rate Over Limit",
            DISSOLVED_OXYGEN_CHANGE_RATE_UNDER_LIMIT: "Dissolved Oxygen Change Rate Under Limit",
            DISSOLVED_OXYGEN_INSIDE_RANGE: "Dissolved Oxygen Inside Range",
            DISSOLVED_OXYGEN_OUTSIDE_RANGE: "Dissolved Oxygen Outside Range",
            DOOR_OPEN: "Door Open",
            DOWNLINK: "Downlink Commands",
            DOWNLINK_COMMANDS: "Downlink Commands",
            DUPLICATE_BUDDY_COUNT: "Duplicate Buddies",
            ECU_FAULT: "Environmental",
            EEPROM_FAILURE_NO_READABLE_BLOCKS: "EEPROM Failure -No Readable Blocks",
            EEPROM_HAN_WRITE_TIMEOUT: "EEPROM/HAN Write Timeout",
            EEPROM_READ_ERROR: "EEPROM Read Error",
            EEPROM_READ_RETRY: "EEPROM Read Retry",
            EMF_RANGE: "EMF Range",
            EMPTY_PIPE: "Empty Pipe",
            ENCRYPTION_FAILED: "Encryption Failed",
            ENDPOINT_DATA: "Endpoint Data",
            ENDPOINT_EVENT: "Endpoint Event",
            EPROM_WEAR: "EPROM Wear",
            EXCESS_FLOW: "Excess Flow",
            EXCESS_FLOW_SHUTOFF: "Excess Flow Shutoff",
            FACTORY_ERROR: "Factory Error",
            FAILED_TO_COMPLETE_METER_FIRMWARE_UPGRADE: "Failed To Complete Meter Firmware Upgrade",
            FAILED_TO_START_METER_FIRMWARE_UPGRADE: "Failed To Start Meter Firmware Upgrade",
            FIXTURE_TYPE_CHANGED: "Fixture Type Changed",
            FLOW_INSIDE_RANGE: "Flow Inside Range",
            FLOW_OUTSIDE_RANGE: "Flow Outside Range",
            FORWARD_POWER: "Forward Power",
            FREE_CHLORINE_CHANGE_RATE_OVER_LIMIT: "Free Chlorine Change Rate Over Limit",
            FREE_CHLORINE_CHANGE_RATE_UNDER_LIMIT: "Free Chlorine Change Rate Under Limit",
            FREE_CHLORINE_INSIDE_RANGE: "Free Chlorine Inside Range",
            FREE_CHLORINE_OUTSIDE_RANGE: "Free Chlorine Outside Range",
            FUSE_FAILURE: "Fuse Failure",
            GLIDE_SLOPE: "Glide Slope",
            GPS: "GPS Error",
            GPS_HARDWARE_FAILURE: "GPS Hardware Failure",
            GPS_LOCATION_CHANGED: "GPS Location Changed",
            GPS_POSITION: "GPS Position",
            GPT: "GPT",
            HARD_EEPROM_ERROR: "HARD EEPROM Error",
            HARD_KWH_ERROR: "Hard Kwh Error",
            HARDWARE_ALERTS_PAUSED: "Hardware Alerts Paused",
            HARDWARE_FAILURE: "Hardware Failure",
            HARDWARE_FAULT: "Hardware Fault",
            HIGH_BG_ALGAE: "High BG Algae",
            HIGH_CHLOROPHYLL: "High Chlorophyll",
            HIGH_COIL_CURRENT: "High Coil Current",
            HIGH_COIL_VOLTAGE: "High Coil Voltage",
            HIGH_CONDUCTIVITY: "High Conductivity",
            HIGH_CURRENT: "High Current",
            HIGH_DC_CURRENT: "High DC Current",
            HIGH_DC_VOLTAGE: "High DC Voltage",
            HIGH_DISSOLVED_OXYGEN: "High Dissolved Oxygen",
            HIGH_FLOW: "High Flow",
            HIGH_FREE_CHLORINE: "High Free Chlorine",
            HIGH_HYDROGEN_SULFIDE: "High Hydrogen Sulfide",
            HIGH_LEVEL: "High Level",
            HIGH_ODORANT_CONCENTRATION: "High Odorant Concentration",
            HIGH_PH: "High pH",
            HIGH_POWER: "High Power",
            HIGH_PRESSURE: "High Pressure",
            HIGH_PRESSURE_SHUTOFF: "High Pressure Shutoff",
            HIGH_PRESSURE_WARNING: "High Pressure Warning",
            HIGH_TEMPERATURE: "High Temperature",
            HIGH_TEMPERATURE_DETECTED: "High Temperature Detected",
            HIGH_TEMPERATURE_SHUTOFF: "High Temperature Shutoff",
            HIGH_TOTAL_CHLORINE: "High Total Chlorine",
            HIGH_TURBIDITY: "High Turbidity",
            HIGH_WEIGHT: "High Weight",
            HISTORY_OVERFLOW: "History Overflow",
            HISTORY_OVERFLOW_GAS: "History Overflow Gas",
            HYDROGEN_SULFIDE_CHANGE_RATE_OVER_LIMIT: "Hydrogen Sulfide Change Rate Over Limit",
            HYDROGEN_SULFIDE_CHANGE_RATE_UNDER_LIMIT: "Hydrogen Sulfide Change Rate Under Limit",
            HYDROGEN_SULFIDE_INSIDE_RANGE: "Hydrogen Sulfide Inside Range",
            HYDROGEN_SULFIDE_OUTSIDE_RANGE: "Hydrogen Sulfide Outside Range",
            IDLE: "Idle",
            IDLE_NOISE: "Idle Noise",
            INDEX_LOST: "Index Lost",
            INTERNAL_COMMUNICATION_ERROR: "Internal Communication Error",
            INTERNAL_FIRMWARE_ERROR_200: "Internal Firmware Error -200",
            INTERNAL_FIRMWARE_ERROR_400: "Internal Firmware Error -400",
            JT_MODULE: "JT_MODULE",
            LAMP_FAILURE: "Lamp Failure",
            LAST_HEARD: "Last Heard",
            LAST_HEARD_ON_AIR: "Last Heard (On Air)",
            LAST_COUNTER_MESSAGE: "Last Counter Message",
            LAST_TRANSMIT_REPORT: "Last Transmit Report",
            LAST_UPLINK_MESSAGE_RECEIVED: "Last Uplink Message Received",
            LEVEL_INSIDE_RANGE: "Level Inside Range",
            LEVEL_OUTSIDE_RANGE: "Level Outside Range",
            LOW_BATTERY_GAS: "Low Battery Gas",
            LOW_BATTERY_SMARTPOINT_LATCHED: "Low Battery Smartpoint Latched",
            LOW_BATTERY_VOLTAGE: "Low Battery Voltage",
            LOW_BATTERY_VOLTAGE_ELECTRIC: "Low Battery Voltage Electric",
            LOW_BG_ALGAE: "Low BG Algae",
            LOW_CHLOROPHYLL: "Low Chlorophyll",
            LOW_COIL_CURRENT: "Low Coil Current",
            LOW_COIL_VOLTAGE: "Low Coil Voltage",
            LOW_CONDUCTIVITY: "Low Conductivity",
            LOW_CURRENT: "Low Current",
            LOW_DC_CURRENT: "Low DC Current",
            LOW_DC_VOLTAGE: "Low DC Voltage",
            LOW_DISSOLVED_OXYGEN: "Low Dissolved Oxygen",
            LOW_FIELD: "Low Field",
            LOW_FLOW: "Low Flow",
            LOW_FREE_CHLORINE: "Low Free Chlorine",
            LOW_HYDROGEN_SULFIDE: "Low Hydrogen Sulfide",
            LOW_LEVEL: "Low Level",
            LOW_LOSS_POTENTIAL: "Low Loss Potential",
            LOW_METROLOGY_BATTERY_VOLTS: "Low Metrology Battery Volts",
            LOW_ODORANT_CONCENTRATION: "Low Odorant Concentration",
            LOW_PH: "Low pH",
            LOW_POWER: "Low Power",
            LOW_POWER_FACTOR: "Low Power Factor",
            LOW_PRESSURE: "Low Pressure",
            LOW_PRESSURE_SHUTOFF: "Low Pressure Shutoff",
            LOW_PRESSURE_WARNING: "Low Pressure Warning",
            LOW_SMARTPOINT_BATTERY_VOLTS: "Low SmartPoint Battery Volts",
            LOW_TEMPERATURE: "Low Temperature",
            LOW_TOTAL_CHLORINE: "Low Total Chlorine",
            LOW_TURBIDITY: "Low Turbidity",
            LOW_VALVE_BATTERY_VOLTS: "Low Valve Battery Volts",
            LOW_WEIGHT: "Low Weight",
            MAGNETIC: "Magnetic",
            MAGNETIC_TAMPER: "Magnetic Tamper",
            MAGNETIC_TAMPER_35_DAY: "Magnetic Tamper 35 Day",
            MAXIMUM_VOLTAGE_HIGH_LIMIT: "Maximum Voltage High Limit",
            MAXIMUM_VOLTAGE_INSIDE_RANGE: "Maximum Voltage Inside Range",
            MAXIMUM_VOLTAGE_LOW_LIMIT: "Maximum Voltage Low Limit",
            MAXIMUM_VOLTAGE_OUTSIDE_RANGE: "Maximum Voltage Outside Range",
            MEASUREMENT_ERROR: "Measurement Error",
            MEMORY_BLOCK_CRC_RETRY: "Memory Block CRC Retry",
            MEMORY_BLOCK_WRITE_ERROR: "Memory Block Write Error",
            MEMORY_ERROR: "Memory Error",
            MEMORY_FULL: "Memory Full",
            MEMORY_WARNING: "Memory Warning",
            MEMORY_WRITE_ERROR: "Memory Write Error",
            MEMORY_WRITE_FAILURE_NO_FREE_BLOCKS: "Memory Write Failure - No Free Blocks",
            META_DATA_WARNING: "Meta Data Warning",
            METER_CHANGED_WARNING: "Meter Changed Warning",
            METER_COMMS_INTERFACE_ERRORS: "Meter Comms Interface Errors",
            METER_COMMUNICATION_FAILED: "Meter Communication Failed",
            METER_COMMUNICATION_FAILURE: "Meter Communication Failure",
            METER_DISCONNECT_TAMPER: "Meter Disconnect Tamper",
            METER_HW_FAILURE: "Meter HW Failure",
            METER_MALFUNCTION_35_DAY_GAS: "Meter Malfunction 35 Day Gas",
            METER_POWER_RESET: "Meter Power Reset",
            METER_PROCESSOR_FAILED: "Meter Processor Failed",
            METER_READ_FAILURE: "Meter Read Failure",
            METER_REBOOT: "Meter Reboot",
            METER_REGISTER_ERROR: "Meter Register Error",
            METER_UNPROGRAMMED: "Meter Unprogrammed",
            METROLOGY_A_PHASE_DISTORTION: "Metrology A Phase Distortion",
            METROLOGY_B_PHASE_DISTORTION: "Metrology B Phase Distortion",
            METROLOGY_BAD_PASSWORD: "Metrology Bad Password",
            METROLOGY_BAD_REGISTER_NUM: "Metrology Bad Register Num",
            METROLOGY_BATTERY_AND_POTENTIAL_FAILURE: "Metrology Battery and Potential Failure",
            METROLOGY_C_PHASE_DISTORTION: "Metrology C Phase Distortion",
            METROLOGY_CALIBRATION_ERROR: "Metrology Calibration Error",
            METROLOGY_CHECKSUM_ERROR: "Metrology Checksum Error",
            METROLOGY_CLOCK_ERROR: "Metrology Clock Error",
            METROLOGY_CODE_ERROR: "Metrology Code Error",
            METROLOGY_CONFIGURATION_ERROR: "Metrology Configuration Error",
            METROLOGY_COVER_DETECT: "Metrology Cover Detect",
            METROLOGY_CROSS_PHASE_RECEIVED_KWH: "Metrology Cross Phase Received KWH",
            METROLOGY_DATA_ERROR: "Metrology Data Error",
            METROLOGY_DC_DETECT: "Metrology DC Detect",
            METROLOGY_DEMAND_OVERLOAD: "Metrology Demand Overload",
            METROLOGY_DSP_ERROR: "Metrology DSP Error",
            METROLOGY_EEPROM_ERROR: "Metrology EEPROM Error",
            METROLOGY_EEPROM_READ_ERROR: "Metrology EEPROM Read Error",
            METROLOGY_FAILURE: "Metrology Failure",
            METROLOGY_FW_UPDATE_FAILED: "Metrology FW Update Failed",
            METROLOGY_HARD_EEPROM_ERROR: "Metrology HARD EEPROM Error",
            METROLOGY_HIGH_DISTORTION: "Metrology High Distortion",
            METROLOGY_HIGH_LINE_CURRENT: "Metrology High Line Current",
            METROLOGY_HIGH_TEMP: "Metrology High Temp",
            METROLOGY_HW_FAILURE: "Metrology HW Failure",
            METROLOGY_INACTIVE_PHASE_CURRENT: "Metrology Inactive Phase Current",
            METROLOGY_INTEGRITY_CHECK: "Metrology Integrity Check",
            METROLOGY_INVERSION_TAMPER: "Metrology Inversion Tamper",
            METROLOGY_LEADING_KVARH: "Metrology Leading KVARH",
            METROLOGY_LOSS_OF_PROGRAM: "Metrology Loss of Program",
            METROLOGY_LOW_BATTERY: "Metrology Low Battery",
            METROLOGY_LOW_BATTERY_SENSOR: "Metrology Low Battery Sensor",
            METROLOGY_LOW_LOSS_POTENTIAL: "Metrology Low Loss Potential",
            METROLOGY_MEASUREMENT_ERROR: "Metrology Measurement Error",
            METROLOGY_MEMORY_WRITE_ERROR: "Metrology Memory Write Error",
            METROLOGY_METER_CHIP_ERROR: "Metrology Meter Chip Error",
            METROLOGY_METER_UNPROGRAMMED: "Metrology Meter Unprogrammed",
            METROLOGY_METERING_ERROR: "Metrology Metering Error",
            METROLOGY_NON_VOLATILE_MEMORY_ERROR: "Metrology Non Volatile Memory Error",
            METROLOGY_OVER_VOLTAGE: "Metrology Over Voltage",
            METROLOGY_OVER_VOLTAGE_PHASE_A: "Metrology Over Voltage Phase A",
            METROLOGY_OVER_VOLTAGE_PHASE_B: "Metrology Over Voltage Phase B",
            METROLOGY_OVER_VOLTAGE_PHASE_C: "Metrology Over Voltage Phase C",
            METROLOGY_PHASE_DIFFERENCE: "Metrology Phase Difference",
            METROLOGY_PROCESSOR_FAILED: "Metrology Processor Failed",
            METROLOGY_RAM_ERROR: "Metrology RAM Error",
            METROLOGY_RAM_TEST_FAIL: "Metrology RAM Test Fail",
            METROLOGY_RECEIVED_KWH: "Metrology Received KWH",
            METROLOGY_REGISTER_CHECK_ERROR: "Metrology Register Check Error",
            METROLOGY_RESET: "Metrology Reset",
            METROLOGY_ROM_ERROR: "Metrology ROM Error",
            METROLOGY_ROM_TEST_FAIL: "Metrology ROM Test Fail",
            METROLOGY_SAMPLE_MISSING: "Metrology Sample Missing",
            METROLOGY_SOFT_EEPROM_ERROR: "Metrology SOFT EEPROM Error",
            METROLOGY_SWITCH_AUTO_CORRECTION_INITIATED: "Metrology Switch Auto-correction Initiated",
            METROLOGY_SWITCH_IN_WRONG_STATE: "Metrology Switch In Wrong State",
            METROLOGY_SYSTEM_ERROR: "Metrology System Error",
            METROLOGY_TAMPER: "Metrology Tamper",
            METROLOGY_TIME_ADJUSTED: "Metrology Time Adjusted",
            METROLOGY_UNAVAILABLE: "Metrology Unavailable",
            METROLOGY_UNDER_VOLTAGE: "Metrology Under Voltage",
            METROLOGY_UNDER_VOLTAGE_PHASE_A: "Metrology Under Voltage Phase A",
            METROLOGY_UNDER_VOLTAGE_PHASE_B: "Metrology Under Voltage Phase B",
            METROLOGY_UNDER_VOLTAGE_PHASE_C: "Metrology Under Voltage Phase C",
            METROLOGY_VOLTAGE_REFERENCE_ERROR: "Metrology Voltage Reference Error",
            METROLOGY_VOLTAGE_UNBALANCE: "Metrology Voltage Unbalance",
            METROLOGY_WATCHDOG_TIMEOUT: "Metrology Watchdog Timeout",
            METROLOGY_WRITE_FAILED: "Metrology Write Failed",
            MINIMUM_VOLTAGE_HIGH_LIMIT: "Minimum Voltage High Limit",
            MINIMUM_VOLTAGE_INSIDE_RANGE: "Minimum Voltage Inside Range",
            MINIMUM_VOLTAGE_LOW_LIMIT: "Minimum Voltage Low Limit",
            MINIMUM_VOLTAGE_OUTSIDE_RANGE: "Minimum Voltage Outside Range",
            MPT_MESSAGE_COUNT: "MPT Messages",
            NATIVE_COUPON_HIGH_VOLTAGE: "Native Coupon High Voltage",
            NATIVE_COUPON_LOW_VOLTAGE: "Native Coupon Low Voltage",
            NATIVE_COUPON_VOLTAGE_INSIDE_RANGE: "Native Coupon Voltage Inside Range",
            NATIVE_COUPON_VOLTAGE_OUTSIDE_RANGE: "Native Coupon Voltage Outside Range",
            NEAR_END_OF_LIFE: "Near End Of Life",
            NON_STANDARD_OPERATION: "Non-standard operation",
            NON_VOLATILE_MEMORY_ERROR: "Non Volatile Memory Error",
            NTP: "NTP Error",
            NTP_ERROR: "NTP Error",
            NTP_DRIFTING: "NTP Drift Above Threshold",
            NTP_MISSING: "NTPD Not Responding",
            ODORANT_CONCENTRATION_INSIDE_RANGE: "Odorant Concentration Inside Range",
            ODORANT_CONCENTRATION_OUTSIDE_RANGE: "Odorant Concentration Outside Range",
            OPEN_CIRCUIT: "Open Circuit",
            OPERATIONAL_ALERTS_PAUSED: "Operational Alerts Paused",
            OPTICAL_PORT_COMMUNICATION_FAILURE: "Optical Port Communication Failure",
            OPTICAL_PORT_LOCKOUT: "Optical Port Lockout",
            OTHER_SENSOR_CHANGE_RATE_OVER_LIMIT: "Other Sensor Change Rate Over Limit",
            OTHER_SENSOR_CHANGE_RATE_UNDER_LIMIT: "Other Sensor Change Rate Under Limit",
            OTHER_SENSOR_HIGH_MEASUREMENT: "Other Sensor High Measurement",
            OTHER_SENSOR_INSIDE_RANGE: "Other Sensor Inside Range",
            OTHER_SENSOR_LOW_MEASUREMENT: "Other Sensor Low Measurement",
            OTHER_SENSOR_OUTSIDE_RANGE: "Other Sensor Outside Range",
            OVER_CURRENT: "Over Current",
            OVER_TEMPERATURE: "Over Temperature",
            OVER_VOLTAGE: "Over Voltage",
            OVERCURRENT: "overCurrent",
            PARTIAL_DATA_MISMATCH: "Partial Data Mismatch",
            PERMANENT_ERROR: "Permanent Error",
            PH_CHANGE_RATE_OVER_LIMIT: "pH Change Rate Over Limit",
            PH_CHANGE_RATE_UNDER_LIMIT: "pH Change Rate Under Limit",
            PH_INSIDE_RANGE: "pH Inside Range",
            PH_OUTSIDE_RANGE: "pH Outside Range",
            PHYSICAL_TAMPER: "Physical Tamper",
            PIPE_HIGH_VOLTAGE: "Pipe High Voltage",
            PIPE_LOW_VOLTAGE: "Pipe Low Voltage",
            PIPE_VOLTAGE_INSIDE_RANGE: "Pipe Voltage Inside Range",
            PIPE_VOLTAGE_OUTSIDE_RANGE: "Pipe Voltage Outside Range",
            POST_INSTALLATION_ALARM_CONFIG_AUDIT: "Post-Installation Alarm Config Audit",
            POST_INSTALLATION_COMMS_AUDIT: "Post-Installation Comms Audit",
            POST_INSTALLATION_LOCATION_AUDIT: "Post-Installation Location Audit",
            POST_INSTALLATION_SENSOR_AUDIT: "Post-Installation Sensor Audit",
            POST_INSTALLATION_SMARTPOINT_CONFIG_AUDIT: "Post-Installation Smartpoint Config Audit",
            POWER_FAIL: "Power Fail",
            POWER_FAIL_BIT_SET: "Power Fail bit set",
            POWER_FAILURE: "Power Failure",
            POWER_OUT: "Power Out",
            POWER_RESTORE: "Power Restore",
            POWER_RESTORE_BIT_SET: "Power Restore bit set",
            POWER_SURGE: "Power Surge",
            PPS: "PPS Error",
            PRE_INSTALLATION_ALARM_CONFIG_AUDIT: "Pre-Installation Alarm Config Audit",
            PRE_INSTALLATION_COMMS_AUDIT: "Pre-Installation Comms Audit",
            PRE_INSTALLATION_LOCATION_AUDIT: "Pre-Installation Location Audit",
            PRE_INSTALLATION_SENSOR_AUDIT: "Pre-Installation Sensor Audit",
            PRE_INSTALLATION_SMARTPOINT_AUDIT: "Pre-Installation Smartpoint Audit",
            PRESSURE_ALERTS_PAUSED: "Pressure Alerts Paused",
            PRESSURE_COMPENSATION_FAILURE: "Pressure Compensation Failure",
            PRESSURE_INSIDE_RANGE: "Pressure Inside Range",
            PRESSURE_OUTSIDE_RANGE: "Pressure Outside Range",
            PROCESSOR_LOW_VOLTAGE: "Processor Low Voltage",
            RADIO_COMMUNICATION_FAILED: "Radio Communication Failed",
            RAM_FAILED: "RAM Failed",
            RAM_TEST_FAIL: "RAM Test Fail",
            RAPID_TEMP_RISE_SHUTOFF: "Rapid Temp Rise Shutoff",
            READ_DATA_QUARANTINE: "Read Data Quarantine",
            READ_FAILURE: "Read Failure",
            RECTIFIER_POWER: "Rectifier Power",
            REFLECTED_POWER: "Reflected Power",
            REGISTER_CHECK_ERROR: "Register Check Error",
            REGISTER_ERROR: "Register Error",
            REGISTER_OVER_TEMPERATURE: "Register Over Temperature",
            RELAY_CORRECTED: "Relay Corrected",
            REMOTE_DISCONNECT_SWITCH_STATE_CHANGED: "Remote Disconnect Switch State Changed",
            RESET_ERROR: "Reset Error",
            REVERSE_ENERGY: "Reverse Energy",
            REVERSE_FLOW: "Reverse Flow",
            REVERSE_FLOW_GAS: "Reverse Flow Gas",
            REVERSE_FLOW_GAS_SMARTPOINT_LATCHED: "Reverse Flow Gas SmartPoint Latched",
            REVERSE_FLOW_SHUTOFF: "Reverse Flow Shutoff",
            ROM_FAILED: "ROM Failed",
            ROM_TEST_FAIL: "ROM Test Fail",
            SEISMIC_EVENT: "Seismic Event",
            SELF_DISCOVERY_FAILURE: "Self-Discovery Failure",
            SENSOR_READ_FAILURE: "Sensor Read Failure",
            SENSOR_READING_FAILED: "Sensor -- Reading Failed",
            SERVICE_LIMITING_CLOSE: "Service Limiting Close",
            SERVICE_LIMITING_OPEN_DUE_TO_HIGH_CURRENT: "Service Limiting Open Due To High Current",
            SERVICE_LIMITING_OPEN_DUE_TO_HIGH_DEMAND: "Service Limiting Open Due To High Demand",
            SINGLE_PHASE_B_FAIL: "Single Phase B Fail",
            SINGLE_PHASE_C_FAIL: "Single Phase C Fail",
            SINGLE_PHASE_FAIL: "Single Phase Fail",
            SOFT_EEPROM_ERROR: "SOFT EEPROM Error",
            SOFT_KWH_ERROR: "Soft Kwh Error",
            STALE_REPORT_DOWNLINK_UNAVAILABLE: "Downlink Unavailable due to Downlink Report Unavailable",
            SWAPPED_METER: "Swapped Meter",
            SWITCH_AUTO_CORRECTION_INITIATED: "Switch Auto-correction Initiated",
            SWITCH_CHATTER_DETECTED: "Switch chatter detected",
            SWITCH_IN_WRONG_STATE: "Switch in wrong state",
            TAMPER: "Tamper",
            TAMPER_CURRENT: "Tamper Current",
            TAMPER_LCM_VOLTAGE: "Tamper LCM Voltage",
            TAMPER_LOAD_VOLTAGE_ON_RELAY_1: "Tamper Load Voltage on Relay 1",
            TAMPER_LOAD_VOLTAGE_ON_RELAY_2: "Tamper Load Voltage on Relay 2",
            TAMPER_LOAD_VOLTAGE_ON_RELAY_3: "Tamper Load Voltage on Relay 3",
            TAMPER_MEASURED_CURRENT_ON_RELAY_1: "Tamper Measured current on Relay 1",
            TAMPER_MEASURED_CURRENT_ON_RELAY_2: "Tamper Measured current on Relay 2",
            TAMPER_MEASURED_CURRENT_ON_RELAY_3: "Tamper Measured current on Relay 3",
            TAMPER_VOLTAGE: "Tamper Voltage",
            TEMPERATURE_ALERTS_PAUSED: "Temperature Alerts Paused",
            TEMPERATURE_COMPENSATION_FAILURE: "Temperature Compensation Failure",
            TEMPERATURE_INSIDE_RANGE: "Temperature Inside Range",
            TEMPERATURE_OUTSIDE_RANGE: "Temperature Outside Range",
            TEMPORARY_ERROR: "Temporary Error",
            TILT_TAMPER: "Tilt Tamper",
            TIME_ADJUSTED: "Time Adjusted",
            TIME_STRAY_DOWNLINK_UNAVAILABLE: "Downlink Unavailable due to Time Stray",
            TOTAL_CHLORINE_CHANGE_RATE_OVER_LIMIT: "Total Chlorine Change Rate Over Limit",
            TOTAL_CHLORINE_CHANGE_RATE_UNDER_LIMIT: "Total Chlorine Change Rate Under Limit",
            TOTAL_CHLORINE_INSIDE_RANGE: "Total Chlorine Inside Range",
            TOTAL_CHLORINE_OUTSIDE_RANGE: "Total Chlorine Outside Range",
            TOUCH_READ_FAILURE: "Touch Read Failure",
            TURBIDITY_CHANGE_RATE_OVER_LIMIT: "Turbidity Change Rate Over Limit",
            TURBIDITY_CHANGE_RATE_UNDER_LIMIT: "Turbidity Change Rate Under Limit",
            TURBIDITY_INSIDE_RANGE: "Turbidity Inside Range",
            TURBIDITY_OUTSIDE_RANGE: "Turbidity Outside Range",
            UNCHANGED_LIGHT_LEVEL: "Unchanged Light Level",
            UNDER_TEMPERATURE: "Under Temperature",
            UNIQUE_BUDDY_COUNT: "Unique Buddies",
            UNKNOWN_GAS: "Unknown Gas",
            UNSATISFACTORY_READING: "Unsatisfactory Reading",
            UNSTABLE_POWER: "Unstable Power",
            UPGRADE_MODE: "Upgrade Mode",
            UPLINK_MESSAGES: "Uplink Messages",
            UPLINK_TRAFFIC_DROP: "Uplink Traffic Drop",
            VALVE_CLOSED: "Valve Closed",
            VALVE_CLOSED_AUTOMATICALLY: "Valve Closed Automatically",
            VALVE_IN_TRANSITION: "Valve in Transition",
            VALVE_OPENED: "Valve Opened",
            VALVE_OPENED_AUTOMATICALLY: "Valve Opened Automatically",
            VALVE_POSITION_UNKNOWN: "Valve Position Unknown",
            VALVE_REDUCED_FLOW: "Valve Reduced Flow",
            VALVE_REDUCED_FLOW_AUTOMATICALLY: "Valve Reduced Flow Automatically",
            VALVE_STATE_CHANGED: "Valve State Changed",
            VALVE_STATE_TEMPORARILY_UNKNOWN_AFTER_REBOOT: "Valve State Temporarily Unknown After Reboot",
            VALVE_TRANSITION_FAILURE: "Valve Transition Failure",
            VERY_LOW_BATTERY_START: "Very Low Battery Start",
            VSWR: "VSWR",
            WATCHDOG_RESET: "Watchdog Reset",
            WEEKLY_HISTORY_OVERFLOW_GAS_SMARTPOINT: "Weekly History Overflow Gas Smartpoint",
            WEEKLY_MAGNETIC_GAS: "Weekly Magnetic Gas",
            WEEKLY_REVERSE_FLOW_GAS: "Weekly Reverse Flow Gas",
            WEIGHT_CHANGE_RATE_OVER_LIMIT: "Weight Change Rate Over Limit",
            WEIGHT_CHANGE_RATE_UNDER_LIMIT: "Weight Change Rate Under Limit",
            WEIGHT_INSIDE_RANGE: "Weight Inside Range",
            WEIGHT_OUTSIDE_RANGE: "Weight Outside Range",
            UNKNOWN: "Unknown"
    },
    baseStationAlarmTypes: {
            AC_POWER_FAIL: "AC Power Fail",
            DOOR_OPEN: "Door Open",
            DOWNLINK_COMMANDS: "Downlink Commands",
            DUPLICATE_BUDDY_COUNT: "Duplicate Buddies",
            ECU_FAULT: "Environmental",
            FORWARD_POWER: "Forward Power",
            FUSE_FAILURE: "Fuse Failure",
            GPS: "GPS Error",
            GPT: "GPT",
            IDLE_NOISE: "Idle Noise",
            JT_MODULE: "JT Module",
            LAST_COUNTER_MESSAGE: "Last Counter Message",
            LAST_HEARD: "Last Heard",
            LAST_HEARD_ON_AIR: "Last Heard (On Air)",
            LAST_TRANSMIT_REPORT: "Last Transmit Report",
            BATTERY: "Low Battery",
            NTP: "NTP Error",
            NTP_DRIFTING: "NTP Drift Above Threshold",
            NTP_MISSING: "NTPD Not Responding",
            OVER_TEMPERATURE: "Over Temperature",
            PPS: "PPS Error",
            RECTIFIER_POWER: "Rectifier Power",
            REFLECTED_POWER: "Reflected Power",
            UNDER_TEMPERATURE: "Under Temperature",
            UNIQUE_BUDDY_COUNT: "Unique Buddies",
            UPLINK_MESSAGES: "Uplink Messages",
            UPLINK_TRAFFIC_DROP: "Uplink Traffic Drop",
            VSWR: "VSWR"
    }
}
